import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import Calender from '../../assets/icon/calender-1-icon.png'
import { useAuth } from '../../contexts/AuthContext'
import { useTranslation } from '../../contexts/TranslationContext'
import { type MeetingDomain } from '../../types/domain/meeting-domain'
import { capitalize } from '../../utils/capitalize'

interface MeetingProps {
  meeting: MeetingDomain
}

export const Meeting = ({ meeting }: MeetingProps) => {
  const [locale] = useTranslation()
  const { user } = useAuth()

  const [dateFormat, setDateFormat] = useState('pt-BR')

  useEffect(() => {
    if (locale === 'en') {
      setDateFormat('en-US')
    } else if (locale === 'es') {
      setDateFormat('es-ES')
    } else {
      setDateFormat('pt-BR')
    }
  }, [locale])

  const formattedDate = capitalize(new Intl.DateTimeFormat(dateFormat, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(new Date(meeting.startAt)))

  const { format: timeFormatter } = new Intl.DateTimeFormat(dateFormat, {
    hour: '2-digit',
    minute: 'numeric',
  })

  const startAtFormatted = timeFormatter(new Date(meeting.startAt))
  const endAtFormatted = timeFormatter(new Date(meeting.endAt))

  const { formatMessage } = useIntl()
  return (
    <div className="h-[10.625rem] px-6 py-4 rounded-lg bg-white border-solid border-[1px] border-grey-500 shadow-[2.5px_4px_5px_rgba(174,174,192,0.4)]">
      <header className="mb-4 overflow-x-hidden text-ellipsis">
        <strong className="text-base font-medium md:text-lg">
          {meeting.summary}
        </strong>
      </header>
      <div className="flex items-start gap-2 mb-6 text-sm md:text-base text-grey-800">
        <img src={Calender} />
        <time>
          <span className="block">{formattedDate}</span>
          <span>{startAtFormatted} - {endAtFormatted}</span>
        </time>
      </div>
      {(meeting.status === 'accomplished' || meeting.status === 'canceled' || meeting.status === 'finished') && (
        <footer>
          {meeting.status === 'canceled' && (
            <span className="px-3 py-1 text-xs md:text-sm text-alert-error rounded-lg bg-[#FFE7E7]">
              {formatMessage({ id: 'MEETING_CANCELED' })}
            </span>
          )}
          {(meeting.status === 'accomplished' || meeting.status === 'finished') && (
            <>
              <span className="mr-2 text-xs font-medium md:text-sm text-grey-800">
                {formatMessage({ id: 'PAYMENT_STATUS' })}:{' '}
              </span>
              {meeting.expertsPayments && meeting.expertsPayments.some(
                (expertPayment) => expertPayment.expert.id === user?.id && expertPayment.paymentStatus === 'paid'
              ) ? (
                <span className="px-3 py-1 text-xs md:text-sm text-alert-success rounded-lg bg-[#E0FAE2]">
                  {formatMessage({ id: 'CONCLUDED' })}
                </span>
                  ) : (
                <span className="px-3 py-1 text-xs md:text-sm text-secondary-light rounded-lg bg-[#E0FFFF]">
                  {formatMessage({ id: 'PENDING' })}
                </span>
                  )}
            </>
          )}
        </footer>
      )}
    </div>
  )
}
